import axios from './axios';

const getOrganization = id =>
  axios({
    method: 'get',
    url: `/v1/organizations/${id}`
  });

export { getOrganization };
